<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-close="close" @vm-action="deleteCategoryConfirm(form)" :vm-action="false" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalImagesVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          uploader(
            v-model="fileList"
            :url="`/api/category-image/${form.id}`"
            title="Upload Images"
            limit="10"
            @on-delete="onDetete"
            @on-change="onChange"
            @on-success="onSuccess"
          )
</template>

<script>
import Uploader from 'vux-uploader-component'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Categories')

export default {
  name: 'ModalCategories',
  components: {
    Uploader
  },
  data () {
    return {
      fileList: []
    }
  },
  props: {
    form: {
      type: Object
    },
    title: {
      default: 'Agregar Imágenes',
      type: String
    }
  },
  validations: {
    form: {
    }
  },
  computed: {
    ...mapGetters([
      'isModalImagesVisible',
      'categoriesCatalog',
      'pagination'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('categories.add') : this.$t('categories.edit')
    }
  },
  methods: {
    ...mapActions([
      'addCategory',
      'editCategory',
      'deleteCategoryImage',
      'setModalImagesVisible',
      'loadCatalog',
      'loadCategories'
    ]),
    async onChange (fileItem, fileList) {
      if (fileItem) {
        await this.loadCategories({ page: this.pagination.currentPage })
      }
    },
    async onDetete (fileItem) {
      if (fileItem) {
        await this.deleteCategoryImage(fileItem.name)
      }
    },
    async onSuccess (res, fileItem) {
      await setTimeout(() => {
        this.fileList.length > 0 && this.fileList.pop()
        this.fileList.push(res)
      }, 700)
      await this.loadCategories({ page: this.pagination.currentPage })
    },
    async deleteCategoryConfirm (category) {
      this.auxDeleteCategory = () => {
        this.deleteCategory(category)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(category.id) }),
        accept: this.auxDeleteCategory
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalImagesVisible(false)
    }
  },
  watch: {
    isModalImagesVisible (flag) {
      if (flag && this.form.images) {
        this.form.images.forEach(item => {
          this.fileList.push({ url: item.thumbUrl, name: item.thumbName })
        })
      } else if (!flag) {
        this.fileList = []
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>
